import { render, staticRenderFns } from "./wdgList.vue?vue&type=template&id=8d02061c&scoped=true&"
import script from "./wdgList.vue?vue&type=script&lang=js&"
export * from "./wdgList.vue?vue&type=script&lang=js&"
import style0 from "./wdgList.vue?vue&type=style&index=0&id=8d02061c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d02061c",
  null
  
)

export default component.exports